import ReactDOM from "react-dom";
import React from "react";
import App from "./App";
import GlobalStyle, { Theme } from "./components/GlobalStyle";
import { ThemeProvider } from "styled-components";

ReactDOM.render(
  <ThemeProvider theme={Theme}>
    <GlobalStyle />
    <App />
  </ThemeProvider>,
  document.getElementById("root")
);
